import { Stack, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SearchButtonClick } from '../../../types/type';
import { SearchIcon } from '../../shared/Svg-icons/App-Icons';
import { MainSearchButton } from './SearchButton-Styles';

const SearchButton = (props: SearchButtonClick) => {
  const theme: Theme = useTheme();

  return (
    <Stack direction="row" spacing={2}>
      <MainSearchButton
        onClick={props.searchButtonClickHandler}
        id="automation_button_search"
        data-testid="automation_button_search"
        variant="outlined"
        sx={{
          '&.MuiButtonBase-root:hover': {
            bgcolor: theme.custom.colors.secondaryColor,
          },
          textTransform: 'none',
          height: theme.custom.styles.defaultInputHeight,
        }}
        endIcon={<SearchIcon />}
      ></MainSearchButton>
    </Stack>
  );
};

export default SearchButton;
